package com.xtream.composeapp.presentation.ui.tvchannels

import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import androidx.lifecycle.compose.collectAsStateWithLifecycle
import com.xtream.composeapp.LocalAppViewModelStoreOwner
import com.xtream.composeapp.data.Screen
import com.xtream.composeapp.presentation.ui.navigation.RootNavViewModel
import com.xtream.composeapp.viewmodel.livetv.StreamControlViewModel
import com.xtream.data_kmp.db.tables.StreamType
import com.xtream.data_kmp.dto.LiveCategory
import org.koin.compose.viewmodel.koinViewModel


@Composable
fun CategorySelectionScreen(
    modifier: Modifier= Modifier,
    type: StreamType= StreamType.LIVE,
    onNavigationIconClick: (() -> Unit)?=null,

    ){



    val viewModelStoreOwner =LocalAppViewModelStoreOwner.current// activity as ViewModelStoreOwner

    val rootNavViewModel: RootNavViewModel = koinViewModel(
        viewModelStoreOwner = viewModelStoreOwner?: error("no viewModelStoreOwner provided")
    )
    val streamControlViewModel: StreamControlViewModel = koinViewModel(
        viewModelStoreOwner = viewModelStoreOwner?: error("no viewModelStoreOwner provided")
    )
    val categoriesUiState: List<LiveCategory> by streamControlViewModel
        .liveCategoriesFlow
        .collectAsStateWithLifecycle(emptyList())



    TvCategoriesTvList(
        modifier = modifier.padding(24.dp),
        title = "Select Category:",
        includeDefaultCategories = false,
        onClick ={

            streamControlViewModel.emitGroup(it)

            rootNavViewModel.navigate(Screen.ManageTvChannels(it))

        },
        streamControlViewModel = streamControlViewModel,
        categoriesUiState = categoriesUiState,
        playingCategory = null,
        isFullScreen = false,
        onNavigationIconClick =onNavigationIconClick,

    )

}